<template>
  <div class="wlx-meet-signUp-wrapper meet-register-detail-main">
    <div class="new-center-content">
      <div class="enter-start-sign-up clearfix">
        <div type="primary" icon="wl-icon-dianji" class="fr start-sign-up-btn" @click="enterSignUp">
          点击报名
          <i class="wl-icon-dianji"></i>
        </div>
      </div>
      <div class="wl-certification-content">
        <div class="border-class-content">
          <h3 class="meet-detail-h3 clearfix">
            <div>{{meetDetail.title}}</div>
          </h3>
          <p style="text-align:center;padding:10px 0;">
            <span class="sp-se-time">报名起止时间:</span>
            <span class="p-meeet-end-time">{{meetDetail.startTime}} ~ {{meetDetail.endTime}}</span>
          </p>
          <div v-html="meetDetail.content" class="meet-detail-content"></div>
        </div>
      </div>
    </div>
    <el-dialog
      :show-close="true"
      :visible.sync="scanVisible"
      top="12%"
      :close-on-click-modal="false"
      width="500px"
      class="unified-login-dialog-style"
    >
      <login></login>
      <p @click="enterRegister" class="p-enter-register">去注册</p>
    </el-dialog>
    <div class="ph-new-center-content">
      <div class="wl-certification-content">
        <div class="border-class-content">
          <h3 class="meet-detail-h3 clearfix">
            <div>{{meetDetail.title}}</div>
          </h3>
          <p style="text-align:center;padding:10px 0;">
            <span class="sp-se-time">报名起止时间:</span>
            <span class="p-meeet-end-time">{{meetDetail.startTime}} ~ {{meetDetail.endTime}}</span>
          </p>
          <div v-html="meetDetail.content" class="meet-detail-content"></div>
          <div type="primary" icon="wl-icon-dianji" class="start-sign-up-btn" @click="enterSignUp">
            点击报名
            <i class="wl-icon-dianji"></i>
          </div>
          <!-- <div class="enter-SignUp-btn">
            <el-button type="primary" @click="enterSignUp">点击报名</el-button>
          </div>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import login from "components/login/login.vue";
export default {
  data() {
    return {
      isTab: 1,
      back: require("assets/images/bg-jieshao.png"),
      TeaAuthenticaList: [],
      pageSize: 10,
      type: 1,
      totalCount: 0,
      currentPage4: 1,
      newsList: [],
      meetDetail: {},
      scanVisible: false
    };
  },
  props: {
    meetId: {
      type: String,
      default: ""
    }
  },
  watch: {
    association: {
      handler(val) {
        // document.title = val.associationName;
      },
      deep: true
    },
    userInfo: {
      handler(val) {
        if (val.code > 0) {
          this.scanVisible = false;
        }
      }
    },
    deep: true
  },
  components: {
    login
  },
  created() {
    this.getMeetDetail();
    document.title = '会议报名';
  },
  computed: {
    association: function() {
      return this.$store.state.association;
    },
    userInfo() {
      return this.$store.state.auth;
    }
  },
  methods: {
    goMeetRegister() {
      this.$router.push({
        name: "meetRegister"
      });
    },
    enterSignUp() {
      // 截至时间操作显示
      let startTime = this.meetDetail.startTime + " 00:00:00";
      let endTime = this.meetDetail.endTime + " 23:59:59";

      let nowTime = "";
      let date = new Date();
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      let hour = date.getHours();
      let miniter = date.getMinutes();
      let second = date.getSeconds();
      nowTime =
        year +
        "/" +
        month +
        "/" +
        day +
        " " +
        hour +
        ":" +
        miniter +
        ":" +
        second;
      // 是否开始
      let isStart = (Date.parse(startTime) - Date.parse(nowTime)) / 3600 / 1000;
      // 是否结束
      let isEnd = (Date.parse(endTime) - Date.parse(nowTime)) / 3600 / 1000;
      // 在起止时间区间内
      if (isStart < 0 && isEnd > 0) {
        this.$router.push({
          name: "signUpTable",
          params: {
            signUpId: this.meetId
          }
        });
      }
      // 还么开始
      if (isStart > 0) {
        this.$message({
          message: "报名还没开始",
          type: "warning"
        });
        return false;
      }
      //已经结束
      if (isEnd < 0) {
        this.$message({
          message: "已超过截止时间",
          type: "warning"
        });
        return false;
      }

      // if (this.userInfo.code < 0) {
      //   this.scanVisible = true;
      // }
      // if (this.userInfo.code > 0 && this.userInfo.userType != 2) {
      //   this.$message({
      //     message: "只有老师才能报名",
      //     type: "warning"
      //   });
      // }
      // if (this.userInfo.code > 0 && this.userInfo.userType == 2) {
      //   this.$router.push({
      //     name: "signUpTable",
      //     params: {
      //       signUpId: this.meetId
      //     }
      //   });
      // }
    },
    getMeetDetail() {
      this.$http
        .post("/api/XOrg/Special/getSpecialInfo", {
          id: this.meetId
        })
        .then(res => {
          if (res.code > 0) {
            this.meetDetail = res.info;
          }
        });
    },
    enterRegister() {
      this.scanVisible = false;
      this.$router.push({
        name: "register"
      });
    },
    open() {
      this.$message({
        showClose: true,
        message: "请在电脑上报名",
        type: "warning",
        customClass: "message-class"
      });
    }
  }
};
</script>

<style lang="scss">
.meet-register-detail-main {
  margin: 0 auto;
  width: 1200px;
  .new-center-list {
    padding: 0 0 30px 0;
  }
  .authen-hade-title {
    border-bottom: 2px solid #e9ebf0;
    .h3-text-title {
      float: left;
      font-size: 20px;
      font-weight: 400;
      line-height: 40px;
      border-bottom: 2px solid #2d82ff;
      position: relative;
      bottom: -2px;
    }
    .authen-hade-crumbs {
      font-size: 14px;
      line-height: 40px;
      color: #a4a4a4;
    }
    .sp-meetTitle-val {
      display: inline-block;
      max-width: 200px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      vertical-align: -14px;
    }
    .sp-line-home {
      margin: 0 5px;
    }
  }
  .border-class-content {
    padding: 0 40px;
  }
  .sp-hover-meet {
    cursor: pointer;
  }
  .p-meeet-end-time {
    margin-top: 20px;
    text-align: center;
    margin-bottom: 10px;
    color: #ec5252;
    font-size: 14px;
  }
  .sp-se-time {
    margin-right: 10px;
    margin-bottom: 10px;
    font-size: 14px;
  }
  .enter-start-sign-up {
    position: fixed;
    top: 50%;
    margin-top: 50px;
    z-index: 1000;
    width: 1200px;
    .start-sign-up-btn {
      background: #2d82ff;
      color: #fff;
      padding: 10px 20px;
      font-size: 18px;
      border-radius: 5px;
      cursor: pointer;
    }
  }
}
@media screen and (max-width: 980px) {
  .meet-register-detail-main {
    width: auto;
    .wl-certification-content {
      min-height: 600px;
    }
    .authen-hade-crumbs {
      padding: 0px 20px;
      height: 40px;
      line-height: 40px;
    }
    .border-class-content {
      padding: 0px 20px 20px;
    }
    .meet-detail-h3 {
      font-size: 16px;
      font-family: MicrosoftYaHei;
      font-weight: normal;
      color: #333333;
      text-align: center;
    }
    .sp-meetTitle-val {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: calc(100% - 180px);
      float: right;
      text-align: left;
    }
    .start-sign-up-btn {
      background: #2d82ff;
      color: #fff;
      padding: 6px 14px;
      font-size: 14px;
      border-radius: 5px;
      cursor: pointer;
      // position: fixed;
      // top: 220px;
      // right: 20px;
      // z-index: 1000;
      width: 74px;
      margin: 15px auto;
    }
  }
  .message-class {
    min-width: 280px;
  }
}
// 会议报名按钮调整
@media only screen and (max-width:1200px) {
  .meet-register-detail-main {
    .enter-start-sign-up {
      width: 1100px;
    }
  }
}
@media only screen and (max-width: 1100px) {
  .meet-register-detail-main {
    .enter-start-sign-up {
      width: 1000px;
    }
  }
}
</style>
